export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-home',
      badge: {
        variant: '',
        text: '',
      },
    },
    {
      name: 'Customers/Suppliers',
      url: '/customers',
      icon: 'icon-list',
      badge: {
        variant: '',
        text: '',
      },
    },
    {
      name: 'Base Users',
      url: '/base-users',
      icon: 'icon-location-pin',
      badge: {
        variant: '',
        text: '',
      },
    },
    {
      name: 'Gas Chromatograph',
      url: '/gc',
      icon: 'icon-speedometer',
      badge: {
        variant: '',
        text: '',
      },
    },
    {
      name: 'Offline Customers',
      url: '/base-list',
      icon: 'icon-grid',
      badge: {
        variant: '',
        text: '',
      },
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'icon-drawer',
      badge: {
        variant: '',
        text: '',
      },
    },

  ],
};
